import { EventEmitter } from 'events'
import devMode from '@/utils/devmode'
import stageMode from '@/utils/stagemode'

function baseUrl(key) {
  let path = ''
  if (window.pathSite) {
    path = window.pathSite
  }
  const devUrl = {
    BASE_URL: `${process.config.URL_DEV}/`,
    SITE: `${process.config.URL_STAGE}/`,
    API_URL: `${process.config.URL_STAGE}/${path}wp-json/wp/v2`,
    API_CUSTOM: `${process.config.URL_STAGE}/${path}wp-json/gusto`,
    API_CF7: `${process.config.URL_STAGE}/${path}wp-json/contact-form-7/v1/contact-forms`,
    API_ECWID: `${process.config.URL_STAGE}/${path}wp-json/ecwid/v2`,
    GA_CODE: '',
    THEME_NAME: process.config.THEME_NAME,
    THEME_DIR: '',
  }
  const prodUrl = {
    BASE_URL: `${process.config.URL_PROD}/`,
    SITE: `${process.config.URL_PROD}/`,
    API_URL: `${process.config.URL_PROD}/${path}wp-json/wp/v2`,
    API_CUSTOM: `${process.config.URL_PROD}/${path}wp-json/gusto`,
    API_CF7: `${process.config.URL_PROD}/${path}wp-json/contact-form-7/v1/contact-forms`,
    API_ECWID: `${process.config.URL_PROD}/${path}wp-json/ecwid/v2`,
    GA_CODE: '',
    THEME_NAME: process.config.THEME_NAME,
    THEME_DIR: `${process.config.URL_PROD}/wp-content/themes/${process.config.THEME_NAME}`,
  }
  const stagedUrl = {
    BASE_URL: `${process.config.URL_STAGE}/`,
    SITE: `${process.config.URL_STAGE}/`,
    API_URL: `${process.config.URL_PROD}/${path}wp-json/wp/v2`,
    API_CUSTOM: `${process.config.URL_PROD}/${path}wp-json/gusto`,
    API_CF7: `${process.config.URL_PROD}/${path}wp-json/contact-form-7/v1/contact-forms`,
    API_ECWID: `${process.config.URL_PROD}/${path}wp-json/ecwid/v2`,
    GA_CODE: '',
    THEME_NAME: process.config.THEME_NAME,
    THEME_DIR: `${process.config.URL_STAGE}/wp-content/themes/${process.config.THEME_NAME}`,
  }
  if (devMode) {
    return devUrl[key]
  }
  if (stageMode) {
    return stagedUrl[key]
  }
  return prodUrl[key]
}

export default {
  urls: {
    BASE_URL: baseUrl('BASE_URL'),
    SITE: baseUrl('SITE'),
    API_URL: baseUrl('API_URL'),
    API_MEDIA: `${baseUrl('API_URL')}/media`,
    API_MAIN_MENU: `${baseUrl('API_CUSTOM')}/nav/main_menu`,
    API_MOBILE_MENU: `${baseUrl('API_CUSTOM')}/nav/mobile_menu`,
    API_EXTRA_MENU: `${baseUrl('API_CUSTOM')}/nav/extra_menu`,
    API_MENU: `${baseUrl('API_CUSTOM')}/nav`,
    API_PAGE: `${baseUrl('API_URL')}/pages`,
    API_POST: `${baseUrl('API_URL')}/posts`,
    API_TAXONOMY: `${baseUrl('API_URL')}/taxonomies`,
    API_ROUTING: `${baseUrl('API_CUSTOM')}/routing-rules`,
    API_STRING: `${baseUrl('API_CUSTOM')}/strings`,
    API_FORM: `${baseUrl('API_CUSTOM')}/form`,
    API_MATERIAL: `${baseUrl('API_CUSTOM')}/materials`,
    API_CF7: baseUrl('API_CF7'),
    API_ECWID: `${baseUrl('API_ECWID')}`,
    HOME_URL: '/',
    VIDEO_DIR: `${baseUrl('THEME_DIR')}/video/`,
    MODEL_DIR: `${baseUrl('THEME_DIR')}/models/`,
    IMG_DIR: `${baseUrl('THEME_DIR')}/images/`,
  },
  status: {
    EMPTY: 'EMPTY',
    PENDING: 'PENDING',
    FULFILLED: 'FULFILLED',
    ERROR: 'ERROR',
  },
  config: {
    THEME_NAME: baseUrl('THEME_NAME'),
    GA_CODE: baseUrl('GA_CODE'),
    POST_PER_PAGE: 12,
    CANVAS_ID: 'webgl',
    CANVAS_ID_MENU: 'webglNav',
    LINK_DELAY: 0,
    LOADER_STATUS: 1,
    LOADER_HIDE_TIME: 1.0,
    TRANSITION_TIME: 1.4,
    TIME_ANIM_HOME: 1.4,
    AUDIO_MP3: `${baseUrl('THEME_DIR')}/audio/ambient.mp3`,
    LOADER_COOKIE: false,
    CUSTOM_TYPE_PREFIX: '_cty_',
    CUSTOM_TAXONOMY_PREFIX: '_cta_',
    RECAPTCHA_SITE_KEY: '6LeZLdIUAAAAAIpb-pRh9fbOcESBIrAkr3LsG6vo',
  },
  webgl: {
    PERFORMANCE_DETECT: true,
    GPU_BLACKLIST: ['radeon hd 6970m', 'radeon hd 6770m', 'radeon hd 6490m', 'radeon hd 6630m', 'radeon hd 6750m', 'radeon hd 5750', 'radeon hd 5670', 'radeon hd 4850', 'radeon hd 4870', 'radeon hd 4670', 'geforce 9400m', 'geforce 320m', 'geforce 330m', 'geforce gt 130', 'geforce gt 120', 'geforce gtx 285', 'geforce 8600', 'geforce 9600m', 'geforce 9400m', 'geforce 8800 gs', 'geforce 8800 gt', 'quadro fx 5', 'quadro fx 4', 'radeon hd 2600', 'radeon hd 2400', 'radeon hd 2600', 'radeon r9 200', 'mali-4', 'mali-3', 'mali-2'],
  },
  EMITTER: new EventEmitter(),
  EVENTS: {
    DATALAYER: {
      COOKIE_CONSENT: 'cookie-consent',
    },
  },
}
